import { Switch } from '../ui/Switch'

interface IncludeOwnerToggleProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  // Override the default "Include owner visits" wording if a surface
  // wants the owner-as-viewer phrasing ("Include my own visits").
  label?: string
}

/**
 * Inline toggle that flips visitor numbers between "external only" (default)
 * and "external + owner". The wording stays in third person ("owner")
 * because the toggle appears on both the creator dashboard (where the
 * viewer IS the owner) and on admin pages (where the viewer is not),
 * and "my own" would mislead admins reviewing someone else's app.
 */
export default function IncludeOwnerToggle({
  checked,
  onCheckedChange,
  label = 'Include owner visits',
}: IncludeOwnerToggleProps) {
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer select-none">
      <span className="text-xs text-muted-foreground">{label}</span>
      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </label>
  )
}
